import React, { useEffect, useState } from "react";
import Tabla from "./Tabla/index";
import estados_icon from "../../../../assets/vw/svg/estados.svg";
import ARCH from "../../../../assets/vw/svg/archivo.svg";
import Loading from "../../../../components/Loading";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../../components/Menu";
import Modal from "../../../../components/Modal";
import NoInfoScreen from "../../../../components/Screens/NoInfoScreen";


function Estados(props) {
  const [dataEstados, setDataEstados] = useState([]);
  const [dataAplicaciones, setDataAplicaciones] = useState([]);
  const [estado, setEstado] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [option, setOption] = useState("estados");
  const [estadosInactivo, setEstadosInactivo] = useState([]);
  const [inactivasFilter, setInactivasFilter] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false
  });

  //Obtiene lo tecleado en el buscador
  const handleChange = (e) => {
    setInactivasFilter([]);
    setEstado([]);
    if (option === "archivo") {
      filtrarInactivas(e.target.value);
    } else {
      filtrar(e.target.value);
    }
  };

  //almacena los datos que hacen MATCH de lo tecleado en el buscador
  const filtrar = (terminoBusqueda) => {
    const resultado = dataEstados.filter((element) => {
      if (
        element.nombre
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        element.descripcion
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase())
      ) {
        return true;
      }

      return false;
    });

    setEstado(resultado); //Obtenemos los match
  };

  const filtrarInactivas = (terminoBusqueda) => {
    const resultado = estadosInactivo.filter((element) => {
      if (
        element.nombre
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        element.descripcion
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setInactivasFilter(resultado); //Obtenemos los match
  };

  const changeOption = (option) => {
    setEstado([])
    setInactivasFilter([])
    setOption(option);
    if (option === "archivo") {
      getEstadosInactivas(dataOriginal);
    }
  };

  const getEstadosInactivas = (data) => {
    const inactivas = data.filter((estado) => {
      return estado.activo === 0;
    });
    setEstadosInactivo(inactivas);
  };


  useEffect(() => {
    Promise.all([
      fetch(
        process.env.REACT_APP_URL_DTO_BACK + "estado?idEstado=",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      ).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(
        process.env.REACT_APP_URL_DTO_BACK + "aplicacion?todos",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      ).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      })
    ]).then(([responseEstados, responseAplicaciones]) => {

      const activas = responseEstados.mensaje.filter((estado) => {
        return estado.activo === 1;
      });
      setDataOriginal(responseEstados.mensaje);
      setDataAplicaciones(responseAplicaciones.mensaje);
      setDataEstados(activas);
      setCargando(false);
    }).catch((error) => {
      console.log(error);
      setCargando(false);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    });
  }, [props.servicio]);

  return (
    <>
      <Menu />
      <Modal modalInfo={modal} setMostrarModal={setModal} />
      {
        cargando && <Loading />
      }
      <div className={`navegacion`}>
        {dataEstados.length > 0 ? (
          <>
            <div className=" posicionMenu">
              <ul className="d-flex flex-row px-0 my-0">
                <li
                  className="opcion-ruta"
                  onClick={() => changeOption("estados")}
                >
                  <div
                    className={`nav-link nav-link-title active ps-0 ${option === "estados" ? " active border_menu" : ""
                      }`}
                  >
                    <img
                      src={estados_icon}
                      alt="estados"
                      className="icono-menu me-3"
                    />
                    Estados
                  </div>
                </li>
                <li
                  className="opcion-ruta"
                  onClick={() => changeOption("archivo")}
                >
                  <div
                    className={`nav-link active ps-0  ${option === "archivo" ? " active border_menu" : ""
                      }`}
                  >
                    <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                    Archivo
                  </div>
                </li>
              </ul>
            </div>
            <div className="row border_vw pt-4 ms-0 mx-0">
              <div className="col-12 p-0 contenedor-table">
                {option === "archivo" ? (
                  <TablaArchivo
                    servicio={props.servicio}
                    estados={
                      inactivasFilter && inactivasFilter.length > 0
                        ? inactivasFilter
                        : estadosInactivo
                    }
                    aplicaciones={dataAplicaciones}
                    handleChange={handleChange}
                  />
                ) : (
                  <Tabla
                    servicio={props.servicio}
                    estados={estado && estado.length > 0 ? estado : dataEstados}
                    aplicaciones={dataAplicaciones}
                    handleChange={handleChange}
                  ></Tabla>
                )}
              </div>
            </div>
            <div
              className={"page__cargando" + (cargando ? " d-block" : " d-none")}
            ></div>
          </>
        ) : (
          <>
            {
              !cargando && <NoInfoScreen />
            }
          </>
        )
        }
      </div>
    </>
  );
}

export default Estados;
